import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-sky-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-232" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-233" data-mp="1y4vej2dwgvin">
        🇦🇷 EL SISTEMA COMPLETO PARA RECUPERAR TU ESPALDA EN ARGENTINA
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-500 md:flex" data-id="element-234" data-mp="2qry77dvwac0z">
        <span className="flex items-center gap-1.5" data-id="element-235" data-mp="2h2oim809fbhm">
          <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-236" data-mp="2h1dbpzbipnma" /> Acceso en 5 minutos
        </span>
        <span className="text-sky-300" data-id="element-237" data-mp="2c2sd24bwzbzy">·</span>
        <span className="flex items-center gap-1.5" data-id="element-238" data-mp="2c1qy3ors25cy">
          <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-239" data-mp="39jr25duiy7bc" /> Pago seguro
        </span>
        <span className="text-sky-300" data-id="element-240" data-mp="34r7qimfedm96">·</span>
        <span className="flex items-center gap-1.5" data-id="element-241" data-mp="34q65bp4o3jdq">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-242" data-mp="26aj453ucts3" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}